// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"cffbd247","82":"fa7388a8","409":"cc802a8a","453":"4939bcd8","500":"cfd2fbda","528":"8f0abd0b","830":"c63b9e0c"}[chunkId] + ".chunk.js";
};